import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withModifiers as _withModifiers, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, vModelCheckbox as _vModelCheckbox } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h2", null, " Alterar Função ", -1)
const _hoisted_2 = { class: "pt-3 pb-2 mb-3" }
const _hoisted_3 = { class: "col-md-12 mb-4" }
const _hoisted_4 = { class: "mb-3" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", null, "Nome", -1)
const _hoisted_6 = { class: "mb-3" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", null, "Descrição", -1)
const _hoisted_8 = { class: "mb-3" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", null, "Nome Menu", -1)
const _hoisted_10 = { class: "mb-3" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", null, "Rota", -1)
const _hoisted_12 = { class: "mb-3" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", null, "Icon", -1)
const _hoisted_14 = { class: "mb-3" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", null, "Observação", -1)
const _hoisted_16 = { class: "mb-3" }
const _hoisted_17 = { class: "btn btn-outline-secondary" }
const _hoisted_18 = /*#__PURE__*/_createTextVNode(" Salvar")
const _hoisted_19 = {
  key: 0,
  class: "col-md-12 mb-4"
}
const _hoisted_20 = {
  key: 0,
  class: "alert alert-success",
  role: "alert"
}
const _hoisted_21 = {
  key: 1,
  class: "alert alert-danger",
  role: "alert"
}
const _hoisted_22 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("h3", null, " Perfils vinculados a Função", -1)
const _hoisted_24 = { class: "mb-3" }
const _hoisted_25 = ["value"]
const _hoisted_26 = /*#__PURE__*/_createElementVNode("div", { class: "mb-3" }, [
  /*#__PURE__*/_createElementVNode("button", { class: "btn btn-outline-secondary" }, "Add Perfils")
], -1)
const _hoisted_27 = {
  key: 0,
  class: "mb-3"
}
const _hoisted_28 = { class: "table-responsive" }
const _hoisted_29 = { class: "table table-striped table-sm" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Selecionar"),
    /*#__PURE__*/_createElementVNode("th", null, "Perfil"),
    /*#__PURE__*/_createElementVNode("th", null, "Consultar"),
    /*#__PURE__*/_createElementVNode("th", null, "Incluir"),
    /*#__PURE__*/_createElementVNode("th", null, "Alterar"),
    /*#__PURE__*/_createElementVNode("th", null, "Excluir")
  ])
], -1)
const _hoisted_31 = ["value"]
const _hoisted_32 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("input", {
    class: "form-check-input",
    type: "checkbox",
    checked: "",
    disabled: ""
  })
], -1)
const _hoisted_33 = ["checked", "value", "onChange"]
const _hoisted_34 = ["checked", "value", "onChange"]
const _hoisted_35 = ["checked", "value", "onChange"]
const _hoisted_36 = {
  key: 1,
  class: "mb-3"
}
const _hoisted_37 = /*#__PURE__*/_createElementVNode("button", { class: "btn btn-outline-secondary" }, " Atualizar", -1)
const _hoisted_38 = [
  _hoisted_37
]
const _hoisted_39 = {
  key: 2,
  class: "col-md-12 mb-4"
}
const _hoisted_40 = {
  key: 0,
  class: "alert alert-success",
  role: "alert"
}
const _hoisted_41 = {
  key: 1,
  class: "alert alert-danger",
  role: "alert"
}
const _hoisted_42 = { class: "pt-3 pb-2 mb-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("a", {
        href: "javascript:void(0)",
        class: "btn btn-sm btn-outline-secondary",
        title: "Voltar",
        onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.voltar()))
      }, [
        _createVNode(_component_font_awesome_icon, { icon: "arrow-circle-left" })
      ])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("form", {
        onSubmit: _cache[7] || (_cache[7] = _withModifiers(
//@ts-ignore
(...args) => ($setup.submit && $setup.submit(...args)), ["prevent"]))
      }, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.data.short_name) = $event)),
            class: "form-control",
            name: "short_name"
          }, null, 512), [
            [_vModelText, $setup.data.short_name]
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.data.long_name) = $event)),
            class: "form-control",
            name: "long_name"
          }, null, 512), [
            [_vModelText, $setup.data.long_name]
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _hoisted_9,
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.data.linkname) = $event)),
            class: "form-control",
            name: "linkname"
          }, null, 512), [
            [_vModelText, $setup.data.linkname]
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _hoisted_11,
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.data.route) = $event)),
            class: "form-control",
            placeholder: "Ex: /nome_da_rota",
            name: "route"
          }, null, 512), [
            [_vModelText, $setup.data.route]
          ])
        ]),
        _createElementVNode("div", _hoisted_12, [
          _hoisted_13,
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (($setup.data.icon) = $event)),
            class: "form-control",
            placeholder: "Icon Menu",
            name: "icon"
          }, null, 512), [
            [_vModelText, $setup.data.icon]
          ])
        ]),
        _createElementVNode("div", _hoisted_14, [
          _hoisted_15,
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (($setup.data.note) = $event)),
            class: "form-control",
            name: "note"
          }, null, 512), [
            [_vModelText, $setup.data.note]
          ])
        ]),
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("button", _hoisted_17, [
            _createVNode(_component_font_awesome_icon, { icon: "save" }),
            _hoisted_18
          ])
        ])
      ], 32),
      ($setup.data.msg)
        ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
            ($setup.data.success)
              ? (_openBlock(), _createElementBlock("div", _hoisted_20, _toDisplayString($setup.data.msg), 1))
              : _createCommentVNode("", true),
            ($setup.data.error)
              ? (_openBlock(), _createElementBlock("div", _hoisted_21, _toDisplayString($setup.data.msg), 1))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", null, [
        _hoisted_22,
        _hoisted_23,
        _createElementVNode("form", {
          onSubmit: _cache[9] || (_cache[9] = _withModifiers(
//@ts-ignore
(...args) => ($setup.storeFuncProfile && $setup.storeFuncProfile(...args)), ["prevent"]))
        }, [
          _createElementVNode("div", _hoisted_24, [
            _withDirectives(_createElementVNode("select", {
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (($setup.selectedPerfils) = $event)),
              class: "form-select",
              multiple: "",
              "aria-label": "multiple select example"
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.perfildisp, (perfil) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: perfil.id,
                  value: perfil.id
                }, _toDisplayString(perfil.id) + " . " + _toDisplayString(perfil.short_name) + " -> " + _toDisplayString(perfil.long_name), 9, _hoisted_25))
              }), 128))
            ], 512), [
              [_vModelSelect, $setup.selectedPerfils]
            ])
          ]),
          _hoisted_26
        ], 32),
        _createElementVNode("form", {
          onSubmit: _cache[11] || (_cache[11] = _withModifiers(
//@ts-ignore
(...args) => ($setup.storeFuncProfileUpdate && $setup.storeFuncProfileUpdate(...args)), ["prevent"]))
        }, [
          ($setup.data.showtableFunc)
            ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                _createElementVNode("div", _hoisted_28, [
                  _createElementVNode("table", _hoisted_29, [
                    _hoisted_30,
                    _createElementVNode("tbody", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.funcProfiles, (perfil) => {
                        return (_openBlock(), _createElementBlock("tr", {
                          key: perfil.id
                        }, [
                          _createElementVNode("td", null, [
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (($setup.excSelPerfils) = $event)),
                              class: "form-check-input",
                              type: "checkbox",
                              value: perfil.id
                            }, null, 8, _hoisted_31), [
                              [_vModelCheckbox, $setup.excSelPerfils]
                            ])
                          ]),
                          _createElementVNode("td", null, _toDisplayString(perfil.id) + " . " + _toDisplayString(perfil.short_name), 1),
                          _hoisted_32,
                          _createElementVNode("td", null, [
                            _createElementVNode("input", {
                              class: "form-check-input",
                              type: "checkbox",
                              checked: $setup.checkedIns(perfil.insert),
                              value: perfil.id,
                              onChange: ($event: any) => ($setup.selectIns(perfil.id, $event.target.checked))
                            }, null, 40, _hoisted_33)
                          ]),
                          _createElementVNode("td", null, [
                            _createElementVNode("input", {
                              class: "form-check-input",
                              type: "checkbox",
                              checked: $setup.checkedUp(perfil.update),
                              value: perfil.id,
                              onChange: ($event: any) => ($setup.selectUp(perfil.id, $event.target.checked))
                            }, null, 40, _hoisted_34)
                          ]),
                          _createElementVNode("td", null, [
                            _createElementVNode("input", {
                              class: "form-check-input",
                              type: "checkbox",
                              checked: $setup.checkedDel(perfil.delete),
                              value: perfil.id,
                              onChange: ($event: any) => ($setup.selectDel(perfil.id, $event.target.checked))
                            }, null, 40, _hoisted_35)
                          ])
                        ]))
                      }), 128))
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          ($setup.data.showtableFunc)
            ? (_openBlock(), _createElementBlock("div", _hoisted_36, _hoisted_38))
            : _createCommentVNode("", true),
          ($setup.data.msg)
            ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                ($setup.data.remover)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_40, _toDisplayString($setup.data.msg), 1))
                  : _createCommentVNode("", true),
                ($setup.data.error)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_41, _toDisplayString($setup.data.msg), 1))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ], 32)
      ])
    ]),
    _createElementVNode("div", _hoisted_42, [
      _createElementVNode("a", {
        href: "javascript:void(0)",
        class: "btn btn-sm btn-outline-secondary",
        title: "Voltar",
        onClick: _cache[12] || (_cache[12] = ($event: any) => ($setup.voltar()))
      }, [
        _createVNode(_component_font_awesome_icon, { icon: "arrow-circle-left" })
      ])
    ])
  ]))
}